module.exports = __webpack_public_path__ + "img/chevron-right-sharp-light.a6d83ba1.svg";